var React = require('react');

function Ok (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704\n\t\tc0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704\n\t\tC78.477,17.894,78.477,18.586,78.049,19.015z"})));
}

Ok.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"78.369px","height":"78.369px","viewBox":"0 0 78.369 78.369","style":{"enableBackground":"new 0 0 78.369 78.369"},"xmlSpace":"preserve"};

module.exports = Ok;

Ok.default = Ok;



// WEBPACK FOOTER //
// ./src/images/icons/ok.svg